export default __webpack_public_path__ + "static/media/usuario-generico.4f418eed.svg";